import { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { Route, Routes, useSearchParams } from 'react-router-dom'

import { FlowSessionState } from 'common/interfaces'
import NotificationsProvider from 'components/NotificationsProvider'
import { SearchAuthProvider } from 'context/SearchAuth'
import { getCompanySlug, useFlowSlug } from 'utils/flow'
import { useLocalStorage } from 'utils/hook'
import ErrorContent from 'views/ErrorContent'
import { FlowView } from 'views/Flow'
import { SessionSearchPage } from 'views/FlowSession'
import { SessionSearchLoginView, SessionSearchProtected } from 'views/Login'

export default function Router(): JSX.Element {
  const flowSlug = useFlowSlug()
  const company = getCompanySlug()

  const [searchParams] = useSearchParams()
  const sessionId = searchParams.get('s_id')
  const [, setSessionFlowId] = useLocalStorage<FlowSessionState['id'] | null>(
    `${flowSlug}/sessionFlowId`,
    null
  )

  useEffect(() => {
    if (sessionId !== null) {
      setSessionFlowId(sessionId)
    }
  }, [])

  return (
    <>
      <SearchAuthProvider>
        <Helmet defaultTitle={company} titleTemplate={`%s | ${company}`} />
        <Routes>
          <Route path=":flowSlug" element={<FlowView />} />
          <Route
            path=":flowSlug/session-search"
            element={
              <SessionSearchProtected>
                <SessionSearchPage />
              </SessionSearchProtected>
            }
          />
          <Route path=":flowSlug/session-search/login" element={<SessionSearchLoginView />} />
          <Route
            path="*"
            element={<ErrorContent title="Not Found" statusCode={404} text="Not Found Page" />}
          />
        </Routes>
        <NotificationsProvider />
      </SearchAuthProvider>
    </>
  )
}
